/**
 * Simple handler to open popup when "Add Custom Size" is clicked
 */

console.log('[MEASUREMENT HANDLER] Simple handler loading for Heritage theme test');

class SimpleCustomSizeHandler {
  constructor() {
    this.init();
  }
  
  init() {
    console.log('[MEASUREMENT HANDLER] Initializing click handler...');
    
    // Listen for clicks on radio buttons and labels
    document.addEventListener('click', (e) => {
      // Check if clicked element is related to "Add Custom Size"
      const isRadio = e.target.type === 'radio' && (e.target.value === 'Add Custom Size' || e.target.value === 'Custom');
      const isLabel = e.target.tagName === 'LABEL' && e.target.textContent.includes('Add Custom Size');
      const isLabelChild = e.target.closest('label') && e.target.closest('label').textContent.includes('Add Custom Size');
      
      if (isRadio || isLabel || isLabelChild) {
        console.log('[MEASUREMENT HANDLER] Add Custom Size clicked');
        
        // Get the label element
        const labelElement = e.target.closest('label') || (e.target.type === 'radio' ? e.target.closest('label') : null);
        
        // If this is a direct user click on an invisible-selected button, we need to clear it and open popup
        if (labelElement && labelElement.classList.contains('invisible-selected')) {
          console.log('[MEASUREMENT HANDLER] Direct click on invisible-selected button - clearing and opening popup');
          // Remove the invisible-selected class immediately
          labelElement.classList.remove('invisible-selected');
          
          // Clear any custom selections
          if (window.customMeasurementPopup && window.customMeasurementPopup.customSizeSelector) {
            window.customMeasurementPopup.customSizeSelector.deselectAllCustomSizes();
          }
        }
        
        // Small delay to allow radio selection to complete
        setTimeout(() => {
          if (window.customMeasurementPopup && !window.customMeasurementPopup.isOpen) {
            console.log('[MEASUREMENT HANDLER] Opening measurement popup');
            window.customMeasurementPopup.openPopupForCustomSize();
          }
        }, 100);
      }
    });
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    console.log('[MEASUREMENT HANDLER] DOM loaded, initializing...');
    new SimpleCustomSizeHandler();
  });
} else {
  console.log('[MEASUREMENT HANDLER] DOM already loaded, initializing...');
  new SimpleCustomSizeHandler();
}